module.exports = __webpack_public_path__ + "img/sidebar_logo.b3e50f01.svg";